import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';
import styled, { withTheme } from 'styled-components';
import { withValue, hook } from '@g4/automation-hooks';
import tracking from '@g4/g4-analytics';

import {
  DOB_DAY_FIELD,
  DOB_MONTH_FIELD,
  EMAIL_FIELD,
} from '../../pageComponents/travelersPage/travelersForm/partsNames';
import { VisuallyHidden } from '../Boneyard';
import { FIELD_ERROR_MESSAGE } from '../../../automationHooks.json';

const propTypes = {
  fieldName: PropTypes.string.isRequired,
  showOwnErrorMessage: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  label: PropTypes.string,
};

const defaultProps = {
  showOwnErrorMessage: true,
  onChange: Function.prototype,
  onBlur: Function.prototype,
};

const ErrorText = styled.em.attrs({ 'aria-live': 'polite', role: 'alert' })`
  font-size: ${props => props.theme.toRem(12)};
  color: ${props => props.theme.colors.common.alertRed};
  padding-top: ${props => props.theme.spacing(2)};
`;

export const Error = React.forwardRef(
  ({ automationHook, id, label, msg }, ref) => {
    return (
      <ErrorText {...hook(automationHook)} id={id} ref={ref}>
        {label && <VisuallyHidden>{label}</VisuallyHidden>}
        {msg}
      </ErrorText>
    );
  }
);

Error.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  automationHook: PropTypes.string,
  theme: PropTypes.object,
  id: PropTypes.string,
  msg: PropTypes.string,
};

const trackError = fieldName => {
  const splittedFieldName = fieldName.split('.');
  const msgFieldName = splittedFieldName[splittedFieldName.length - 1];
  if (
    (msgFieldName === DOB_DAY_FIELD || msgFieldName === DOB_MONTH_FIELD) &&
    ErrorMessage(fieldName)._owner.pendingProps.formik.submitCount
  ) {
    tracking.trackEvent('client_side_error', 'Traveler - DOB Not Entered');
  }

  if (msgFieldName === EMAIL_FIELD) {
    tracking.trackEvent(
      'client_side_error',
      'Traveler - Invalid Email Address'
    );
  }
};

const FieldError = React.memo(({ fieldName, label }) => {
  return (
    <ErrorMessage name={fieldName}>
      {msg => {
        trackError(fieldName);

        return (
          <Error
            automationHook={withValue(FIELD_ERROR_MESSAGE.hook, fieldName)}
            id={`${fieldName}_error`}
            label={label}
            msg={msg}
          />
        );
      }}
    </ErrorMessage>
  );
});

FieldError.propTypes = propTypes;
FieldError.defaultProps = defaultProps;

FieldError.propTypes = {
  fieldName: PropTypes.string,
  ...FieldError.propTypes,
};

export default withTheme(FieldError);
